import { isIE } from 'shared/helpers'
import { Dayjs } from 'dayjs'
import dayjs from 'shared/dayjs'
import { getUTCDateFromTimeZoneDate } from 'front-end/src/pages/manage-events/event-edit/tabs/event-detail/eventDetailUtils'
import {
  SessionDocument,
  SessionQuery
} from 'front-end/src/public-api/hooks/usePublicApiSession.codegen'
import { apolloClientPublic } from 'front-end/src/graphql/apolloClient'

export function dayjsTz(
  value: string | Date | Dayjs,
  timezone?: string,
  keepLocalTime?: boolean
): Dayjs {
  const loggedUser = apolloClientPublic.readQuery<SessionQuery>({
    query: SessionDocument,
    variables: {
      sid: null
    }
  })
  const userTz = loggedUser?.session?.user.timezone ?? dayjs.tz.guess() ?? 'UTC'
  if (isIE) return dayjs(value)
  return dayjs(value).tz(timezone ? timezone : userTz, keepLocalTime)
}

/**
 * @description August 16, 2018
 */
export const formatDateLong = (
  date: string | Date | null | undefined
): string => {
  return date ? dayjsTz(date).format('LL') : ''
}

/**
 * @description August 16, 2018 8:02 PM
 */
export const formatDateAndTimeLong = (
  date: string | Date | null | undefined
): string => {
  return date ? dayjsTz(date).format('LLL') : ''
}

/**
 * @description 8/16/2018
 */
export const formatDateShort = (
  date: string | Date | null | undefined
): string => {
  return date ? dayjsTz(date).format('L') : ''
}

/**
 * @description 08/16/2018 8:02 PM
 */
export const formatDateAndTimeShort = (
  date: string | Date | null | undefined
): string => {
  return date ? dayjsTz(date).format('L LT') : ''
}

/**
 * @description Aug 16, 2018
 */
export const formatDateShorter = (
  date: string | Date | null | undefined
): string => {
  return date ? dayjsTz(date).format('ll') : ''
}

/**
 * Checks if date is in future at least at 3 minutes
 * */
export const checkIsValidFutureDate = (
  fixedDate: Dayjs | null,
  timezone?: string | null
) => {
  return (
    !!fixedDate &&
    fixedDate.isValid() &&
    dayjs
      .utc()
      .add(3, 'minutes')
      .isBefore(
        getUTCDateFromTimeZoneDate({
          date: fixedDate,
          timezone: timezone || dayjs.tz.guess()
        })
      )
  )
}
